export default "__VITE_ASSET__88e63c3c__"